import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onBeforeUnmount } from 'vue';
import DeviceSelect from './DeviceSelect.vue';
import { useRoomStore } from '../../../stores/room';
import { SettingMode } from '../../../constants/render';

interface Props {
  mode?: SettingMode,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AudioSettingTab',
  props: {
    mode: null
  },
  setup(__props: any) {

const props = __props as {
  mode?: SettingMode,
}


const settingMode = props.mode || SettingMode.SIMPLE;
const isSampleMode = computed(() => settingMode === SettingMode.SIMPLE);
const isDetailMode = computed(() => settingMode === SettingMode.DETAIL);

const roomStore = useRoomStore();
// const inputAudioLevel = ref(0);
// const outputAudioLevel = ref(100);

const volumeTotalNum = computed(() => (isDetailMode.value ? 36 : 28));

const volumeNum = computed(() => (roomStore.localStream.audioVolume || 0) * volumeTotalNum.value / 100);

const showVolume = computed(() => isSampleMode.value || (isDetailMode.value && isTestingMicrophone.value));

const isTestingMicrophone = ref(false);
// 点击麦克风【测试】按钮
function handleMicrophoneTest() {
  isTestingMicrophone.value = !isTestingMicrophone.value;
}

const isTestingSpeaker = ref(false);
const audioPlayer = document.createElement('audio');
// 点击扬声器【测试】按钮
function handleSpeakerTest() {
  if (isTestingSpeaker.value) {
    audioPlayer.pause();
    audioPlayer.currentTime = 0;
    isTestingSpeaker.value = false;
  } else {
    isTestingSpeaker.value = true;
    audioPlayer.src = 'https://web.sdk.qcloud.com/trtc/electron/download/resources/media/TestSpeaker.mp3';
    audioPlayer.play();
  }
}

onBeforeUnmount(() => {
  audioPlayer.pause();
});


return { __sfc: true,props, settingMode, isSampleMode, isDetailMode, roomStore, volumeTotalNum, volumeNum, showVolume, isTestingMicrophone, handleMicrophoneTest, isTestingSpeaker, audioPlayer, handleSpeakerTest, DeviceSelect }
}

})